import { useApiWrapper } from './apiWrapper';
import { PreSignedUrlReq } from '../../dto/ReqDtoRepository';
import { getPreSignedUrl } from '../../api/preSignedUrlApi';
import { PreSignedUrlResponse } from '../../dto/ResDtoRepository';
import { usePageOwnerIdentityStore } from '../../store/pageOwnerIdentityStore';
import { runCurrentArchiveRequest } from '../../util/currentArchiveRequest';


interface UsePreSignedResult {
  getPreSignedUrl: (data: PreSignedUrlReq) => Promise<string | undefined>;
}

export const usePreSigned = (): UsePreSignedResult => {
  const withApiHandler = useApiWrapper();
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);


  const handlePreSignedUrlSuccess = (response: PreSignedUrlResponse) => {
    return response.data.preSignedUrl;
  };

  const handlePreSignedUrlRequest = async (
    action: 'post',
    data: PreSignedUrlReq
  ): Promise<string | undefined> => {
    if (!pageOwner) return;
    const { aui } = pageOwner;
    const apiFunction = async () => {
      switch (action) {
        case 'post':
        default:
          return runCurrentArchiveRequest(
            aui,
            () => getPreSignedUrl(aui, data),
            handlePreSignedUrlSuccess,
          );
      }
    };
    return await withApiHandler(apiFunction, [aui, action, data]);
  };

  const getPreSignedUrlHandler = (data: PreSignedUrlReq) => handlePreSignedUrlRequest('post', data);

  return {
    getPreSignedUrl: getPreSignedUrlHandler,
  };
};
